import { SeriesPointXY } from '../Types';

function getOrigin<K extends SeriesPointXY>(point: K, value: number | null, origin?: number | ((point: K) => number)): number | null;
function getOrigin<K extends SeriesPointXY>(point: K, vlaue?: number | null, origin?: number | ((point: K) => number)): undefined | number | null;
function getOrigin<K extends SeriesPointXY>(point: K, value?: number | null, origin?: number | ((point: K) => number)) {
  if (origin === undefined) {
    return value;
  } else if (typeof origin === 'function') {
    return origin(point);
  }

  return origin;
}

export default getOrigin;
